import { types } from 'mobx-state-tree'

export const PagingMetadataModel = types
  .model('PagingMetadataModel', {
    num_pages: types.number,
    page_number: types.number,
    total_results: types.number,
    page_size: types.number,
  })
  .views((self) => ({
    get totalPages(): typeof self.num_pages {
      return self.num_pages
    },
    get currentPage(): typeof self.page_number {
      return self.page_number
    },
  }))
  .views((self) => ({
    get totalResults(): typeof self.total_results {
      return self.total_results
    },
  }))
